import Vue from 'vue'

/**
 * @author Jorge Nunez L.
 *
 * @param payload sinister's cancellation to be sent
 *
 * Creates a new cancellation log 
 */

export default (payload) =>
  Vue.$http.post('sinister/view/sinister-cancellation-reason/', payload)
    .then(response => response.data)
